import type { components } from '@multaqa/api-client'
import { useQuery } from '@tanstack/react-query'
import { categoryKeys, fetchProductCategories } from '@/components/directory/category-query-keys'
import { api } from '@/lib/api'

export type CategoryOption = components['schemas']['ProductCategoryResource']
export type CollectionOption = components['schemas']['CollectionResource']

/** Active categories, under the key the product-categories screens invalidate. */
export function useScopeCategories(enabled: boolean) {
  const params = { is_active: true }
  return useQuery({
    queryKey: categoryKeys.list(params),
    enabled,
    queryFn: async (): Promise<CategoryOption[]> => (await fetchProductCategories(params)) ?? [],
  })
}

/** The company's collections, under the key the collections screens invalidate. */
export function useScopeCollections(companyId: string | null, enabled: boolean) {
  return useQuery({
    queryKey: ['collections', companyId] as const,
    enabled: Boolean(companyId) && enabled,
    queryFn: async (): Promise<CollectionOption[]> => {
      const response = await api.GET('/companies/{company}/collections', {
        params: { path: { company: companyId ?? '' } },
      })
      return response.data?.data ?? []
    },
  })
}
